import { useLocation } from 'react-router';

const PARENT_LABELS: Record<string, string> = {
  '/': 'Dashboard',
  '/tutors': 'Find Tutors',
  '/bookings': 'My Bookings',
  '/referrals': 'Referrals',
};

const TUTOR_LABELS: Record<string, string> = {
  '/': 'Dashboard',
  '/tutor/bookings': 'My Classes',
  '/tutor/earnings': 'Earnings',
};

const ONBOARDING_STEP_TITLES: Record<string, string> = {
  identity: 'Your Identity',
  subjects: 'What You Teach',
  bio: 'About You',
  rate: 'Your Rate',
  photo: 'Profile Photo',
  bank: 'Payout Details',
  review: 'Review & Publish',
};

export function usePageTitle(role: string | undefined): {
  label: string;
  parent?: { label: string; href: string };
} {
  const { pathname } = useLocation();
  const labels = role === 'tutor' ? TUTOR_LABELS : PARENT_LABELS;

  if (pathname.startsWith('/tutors/') && pathname !== '/tutors') {
    return { label: 'Tutor Profile', parent: { label: 'Find Tutors', href: '/tutors' } };
  }

  if (pathname.startsWith('/onboarding')) {
    const stepKey = pathname.split('/')[2] ?? '';
    const stepTitle = ONBOARDING_STEP_TITLES[stepKey];
    return {
      label: stepTitle ?? 'Setup Profile',
      parent: { label: 'Setup Profile', href: '/onboarding' },
    };
  }

  return { label: labels[pathname] ?? 'Dashboard' };
}
